import React from 'react';
import { motion } from 'framer-motion';
import { Check, FileText, ListChecks, Clock } from 'lucide-react';
export function ContentsSection() {
  const bonuses = [{
    icon: <FileText className="w-6 h-6 text-[#C9A96E]" data-id="element-1" />,
    title: 'Tarjeta 3AM',
    desc: '1 página para la mesa de noche'
  }, {
    icon: <ListChecks className="w-6 h-6 text-[#C9A96E]" data-id="element-2" />,
    title: 'Checklist “Cama Lista”',
    desc: 'Para preparar el entorno'
  }, {
    icon: <Clock className="w-6 h-6 text-[#C9A96E]" data-id="element-3" />,
    title: 'Registro de 14 días',
    desc: '1 minuto por mañana'
  }];
  return <section className="w-full bg-[#FAF6F0] py-20 px-6 md:px-8" data-id="element-4">
      <div className="max-w-4xl mx-auto" data-id="element-5">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-6">
          <h2 className="font-serif text-3xl md:text-4xl text-[#1B2141] mb-12 text-center" data-id="element-7">
            ¿Qué obtienes exactamente?
          </h2>

          <div className="bg-white rounded-2xl p-8 md:p-10 shadow-sm border border-[#E8E0D4] mb-12" data-id="element-8">
            <ul className="space-y-6" data-id="element-9">
              {['El método Mapa 3-Bloques explicado en lenguaje simple', 'El paso a paso de la Re-Entrada al Sueño (7 minutos)', 'Qué hacer si te despiertas por: baño, calor, ruidos, dolor, o preocupación repetitiva', 'El Plan guiado de 14 noches (para convertirlo en reflejo)'].map((item, i) => <li key={i} className="flex items-start text-lg md:text-xl text-[#2D2D2D]" data-id="element-10">
                  <Check className="w-6 h-6 text-[#C9A96E] mr-4 mt-1 flex-shrink-0" data-id="element-11" />
                  <span data-id="element-12">{item}</span>
                </li>)}
            </ul>
          </div>

          <h3 className="font-serif text-2xl text-[#1B2141] mb-8 text-center" data-id="element-13">
            Incluye 3 Bonos Imprimibles:
          </h3>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-14">
            {bonuses.map((bonus, i) => <motion.div key={i} whileHover={{
            y: -5
          }} className="bg-white p-6 rounded-xl border border-[#C9A96E]/30 shadow-sm text-center flex flex-col items-center" data-id="element-15">
                <div className="mb-4 p-3 bg-[#FAF6F0] rounded-full" data-id="element-16">
                  {bonus.icon}
                </div>
                <h4 className="font-bold text-[#1B2141] text-lg mb-2" data-id="element-17">
                  {bonus.title}
                </h4>
                <p className="text-[#4A4A4A] text-sm" data-id="element-18">{bonus.desc}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}